import {
    FirebaseDynamicLinks
} from '@pantrist/capacitor-firebase-dynamic-links';
import { setDynamicLinkParams } from 'app/actions/App/action';
import { store } from 'app/store';
import { deepLinkObjCreation } from './common';
import { ADJUST, KEYS } from './constants';

export const readAndStoreDynamicLinkAttributes = () => {
    FirebaseDynamicLinks.addListener('deepLinkOpen', (data: any) => {
        const deepLinkURL = data.url;
        const params = (new URL(deepLinkURL)).searchParams;
        const deepLinkURI = params.get('deepLinkURI');
        const paramsDict = params.get('params');
        if (deepLinkURI) {
            try {
                store.dispatch(setDynamicLinkParams({
                    paramsDict: paramsDict ? {
                        ...deepLinkObjCreation(paramsDict)
                    } : null,
                    deepLinkURI: deepLinkURI
                }));


                setTimeout(() => {
                    store.dispatch(setDynamicLinkParams({}));
                }, 180000);
            } catch (error) {
                console.log("error:::", error);
            }
        }
    });
}

export const readAndStoreDynamicLinkAttributesWeb = (data: any) => {
    const deepLinkURL = data;
    const params = (new URL(deepLinkURL)).searchParams;
    const deepLinkURI = params.get('deepLinkURI');
    const paramsDict = params.get('params') as any;
    const dynamicLinkSource = params.get('dynamicLinkSource');
    const adjustSource = params.get('adj_t');

    if (dynamicLinkSource === ADJUST || adjustSource === KEYS.ADJUST_CONFIG.linkToken) {
        return;
    }

    if (deepLinkURI) {
        try {
            window && window.sessionStorage.setItem("deepLinkURI", deepLinkURI);
            paramsDict && window && window.sessionStorage.setItem("params", JSON.stringify({ ...deepLinkObjCreation(paramsDict) }));
            setTimeout(() => {
                store.dispatch(setDynamicLinkParams({}));
            }, 180000);

        } catch (error) {
            console.log("Error handling Firebase deeplink web:", error);
        }
    }
}

export const handleAdjustDeeplink = (deeplink: string) => {
    const deepLinkURL = new URL(deeplink);
    const params = deepLinkURL.searchParams;
    const deepLinkURI = params.get('deepLinkURI');
    const paramsDict = params.get('params');
    const dynamicLinkSource = params.get('dynamicLinkSource');
    const adjustSource = params.get('adj_t');

    if ((deepLinkURI && dynamicLinkSource === ADJUST) || (deepLinkURI && adjustSource === KEYS.ADJUST_CONFIG.linkToken)) {
        try {
            store.dispatch(setDynamicLinkParams({
                paramsDict: paramsDict ? {
                    ...deepLinkObjCreation(paramsDict)
                } : null,
                deepLinkURI: deepLinkURI
            }));
            setTimeout(() => {
                store.dispatch(setDynamicLinkParams({}));
            }, 180000);
        }
        catch (error) {
            console.error('Error handling Adjust deeplink:', error);
            store.dispatch(setDynamicLinkParams({ deepLinkURI: deeplink, paramsDict: null }));
        }
    }
};

export const handleAdjustDeepLinkWeb = (data: any) => {
    const deepLinkURL = data;
    const params = (new URL(deepLinkURL)).searchParams;
    const deepLinkURI = params.get('deepLinkURI');
    const paramsDict = params.get('params') as any;
    const deepLinkProduct = params.get('dynamicLinkSource');
    const adjustSource = params.get('adj_t');

    if (deepLinkURI && deepLinkProduct === ADJUST || deepLinkURI && adjustSource === KEYS.ADJUST_CONFIG.linkToken) {
        try {
            window && window.sessionStorage.setItem("deepLinkURI", deepLinkURI);
            paramsDict && window && window.sessionStorage.setItem("params", JSON.stringify({ ...deepLinkObjCreation(paramsDict) }));
            setTimeout(() => {
                store.dispatch(setDynamicLinkParams({}));
            }, 180000);

        } catch (error) {
            console.log("Error handling Adjust deeplink web:", error);
        }
    }
}